// extracted by mini-css-extract-plugin
export default {"wrapper":"Notify_wrapper__Bdzsb"};